import React, { useEffect } from 'react';

import {
  ActionSection,
  ContentSection,
  HeroSection,
} from '../sections';

const BaseStaticPage = ({ content, metadata }) => {
  useEffect(() => {
    if (!metadata) {
      return;
    }

    document.title = metadata.title;

    if (metadata.description) {
      const descriptionTag = document.querySelector('meta[name="description"]');
      if (descriptionTag) {
        descriptionTag.setAttribute('content', metadata.description);
      }
    }
  }, [metadata]);

  if (!content) {
    return null;
  }

  return (
    <>
      <HeroSection {...content.hero} />
      {content.contentBlocks.map((block) => (
        <ContentSection
          key={block.title}
          title={block.title}
          paragraphs={block.paragraphs}
          cards={block.cards}
        />
      ))}
      <ActionSection {...content.action} />
    </>
  );
};

export default BaseStaticPage;
